export const createVirtualElementWithHtml = (elementHtml: string): HTMLDivElement => {
  const element = document.createElement('div');
  element.innerHTML = elementHtml;
  return element;
};
